import { render, staticRenderFns } from "./Kapures.vue?vue&type=template&id=565aad8e&"
import script from "./Kapures.vue?vue&type=script&lang=js&"
export * from "./Kapures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports